export default function useRegisterPushNotifications() {
  // no-op for web
}
